import React from "react";
import { Box, Button, Card, Stack, Typography } from "@mui/material";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";

export default function SprintSharedContextCard({
  focusLine,
  partnerFocusLine,
  partnerName = "Your TrustBud",
  onViewPlan,
  onViewPartnerFocus,
}) {
  return (
    <Card
      variant="outlined"
      sx={{
        p: 1.55,
        borderRadius: "8px",
        borderColor: "#dde6ef",
        boxShadow: "0 10px 22px rgba(15, 23, 42, 0.04)",
      }}
    >
      <Stack spacing={1.25}>
        <Typography sx={{ fontSize: "1rem", fontWeight: 800, color: "#102033" }}>
          Accountability focus
        </Typography>
        <Stack direction="row" spacing={1.2} alignItems="center">
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "#f4f7fb",
              color: "#5f7289",
              flexShrink: 0,
            }}
          >
            <FlagOutlinedIcon fontSize="small" />
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="caption"
              sx={{ color: "#8b9bb0", fontWeight: 800, letterSpacing: 0 }}
            >
              YOU
            </Typography>
            <Typography
              sx={{
                mt: 0.35,
                fontWeight: 800,
                color: "#102033",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {focusLine || "General consistency"}
            </Typography>
          </Box>

          {onViewPlan ? (
            <Button
              variant="text"
              onClick={onViewPlan}
              sx={{
                textTransform: "none",
                fontWeight: 800,
                minWidth: "auto",
                px: 0,
                color: "#23458a",
              }}
            >
              Open Plan
            </Button>
          ) : null}
        </Stack>

        <Stack direction="row" spacing={1.2} alignItems="center">
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "#f4f7fb",
              color: "#5f7289",
              flexShrink: 0,
            }}
          >
            <FlagOutlinedIcon fontSize="small" />
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="caption"
              sx={{ color: "#8b9bb0", fontWeight: 800, letterSpacing: 0 }}
            >
              {partnerName.toUpperCase()}
            </Typography>
            <Typography
              sx={{
                mt: 0.35,
                fontWeight: 800,
                color: "#102033",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {partnerFocusLine || "Private focus"}
            </Typography>
          </Box>

          {onViewPartnerFocus ? (
            <Button
              variant="text"
              onClick={onViewPartnerFocus}
              sx={{
                textTransform: "none",
                fontWeight: 800,
                minWidth: "auto",
                px: 0,
                color: "#23458a",
              }}
            >
              View {partnerName}
            </Button>
          ) : null}
        </Stack>
      </Stack>
    </Card>
  );
}
